import { Link } from 'react-router-dom';
import styled from 'styled-components';
export const customTableStyles = {
    noData: {
        style: {
            padding: '32px',
            minHeight: '500px',
        },
    },
    progress: {
        style: {
            padding: '32px',
            minHeight: '500px',
        },
    },
    tableWrapper: {
        style: {
            minHeight: '514px',
        },
    },
    headRow: {
        style: {
            fontSize: '10px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '.12em',
            padding: '0 44px',
            borderBottomColor: '#ECEFF3',
        },
    },
    headCells: {
        style: { padding: '24px 8px', minHeight: '70px' },
    },
    rows: {
        style: {
            padding: '0 44px',
            '&:nth-child(even)': {
                backgroundColor: '#F5F7F9',
            },
            border: 'none',
        },
    },
    cells: {
        style: { padding: '24px 8px' },
    },
    pagination: {
        style: {
            borderTopColor: '#ECEFF3',
        },
    },
};
export const ReviewLink = styled(Link) `
  color: ${({ $disabled = false }) => ($disabled ? '#B0BEC5' : '#1662e5')};
  font-weight: 700;
  text-decoration: none;
  cursor: ${({ $disabled = false }) => ($disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${({ $disabled = false }) => ($disabled ? 'none' : 'auto')};
`;
export const Strikethrough = styled.span `
  border-radius: 2px;
  padding: 8px 27px;
  background-color: ${({ $level }) => {
    switch ($level) {
        case 'very-high':
            return '#FF0000';
        case 'high':
            return '#FFE3E3';
        case 'medium':
            return '#FFF5E3';
        case 'very-low':
            return '#E3F2FD';
        case 'low':
            return '#DFF9ED';
    }
}};
  color: ${({ $level }) => {
    switch ($level) {
        case 'very-high':
            return '#FFFFFF';
        case 'high':
            return '#C43333';
        case 'medium':
            return '#8C6624';
        case 'low':
            return '#00A86C';
        case 'very-low':
            return '#1976D2';
    }
}};
`;
export const ProcessesContainer = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: space-between;
  gap: 16px;

  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
